// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__z6KFn","loaderOuter":"PageOverlayLoader_loaderOuter__1vZ0C"};